import { Record } from "immutable";
import { formatCurrency } from "utilities";
export class AggregateDistributorData extends Record({
    id__count: null,
    total_ledgers__sum: null,
    total_retailers__sum: null,
    total_sales__sum: null,
    net_sales_amount_last_12_months: null,
    limit_basis_sales: null,
    limit_basis_tenor_: null,
    eligible_retailers: null
}){
    getDisplayData() {
        return {
            "Total Distributors": this.id__count,
            "Total Ledgers": formatCurrency(this.total_ledgers__sum, true),
            "Total Retailers": formatCurrency(this.total_retailers__sum, true),
            "Total Sales": formatCurrency(this.total_sales__sum, true),
            "Eligible Retailers": this.eligible_retailers || "--",
            "Net Sales Last 12 Months": formatCurrency(this.net_sales_amount_last_12_months, true),
            "Limit Basis Sales": formatCurrency(this.limit_basis_sales, true),
            "Limit Basis Tenor": formatCurrency(this.limit_basis_tenor_, true)
        };
    }
}

export class DistributorDataRecord extends Record({
    id: null,
    create_date: null,
    modified_date: null,
    ledger_master__seller__gstin: null,
    is_active: false,
    distributor_name: null,
    distributor_gstin: null,
    tally_company_code: null,
    total_ledgers: null,
    total_retailers: null,
    total_sales: null,
    as_on_date: null,
    created_by: null,
    updated_by: null,
    company: null,
    uapr_id: null,
    net_sales_amount_last_12_months__sum: null,
    limit_basis_sales__sum: null,
    limit_on_tenor__sum: null,
    id__count: null
}){}